module.exports = __webpack_public_path__ + "img/arrow-green.847552c2.svg";